var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20799 9.375C1.02799 9.19434 0.937988 8.986 0.937988 8.75C0.937988 8.514 1.02799 8.30567 1.20799 8.125L4.33299 5L1.20799 1.875C1.02799 1.69434 0.937988 1.486 0.937988 1.25C0.937988 1.014 1.02799 0.80567 1.20799 0.625004C1.38865 0.444337 1.59699 0.354004 1.83299 0.354004C2.06965 0.354004 2.27799 0.444337 2.45799 0.625004L6.20799 4.375C6.30532 4.47234 6.37499 4.573 6.41699 4.677C6.45832 4.781 6.47899 4.88867 6.47899 5C6.47899 5.11134 6.45832 5.219 6.41699 5.323C6.37499 5.427 6.30532 5.52767 6.20799 5.625L2.45799 9.375C2.27799 9.55567 2.06965 9.646 1.83299 9.646C1.59699 9.646 1.38865 9.55567 1.20799 9.375Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallForward);
export default __webpack_public_path__ + "static/media/small-forward.d482523eaa1047471df01febfac84fce.svg";
export { ForwardRef as ReactComponent };